import { getDeviceType } from './detect'

const MOBILE_MAX_WIDTH = 1024

export const isMobileDevice = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  const isTouchMac = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const deviceType = getDeviceType()

  return (
    deviceType !== 'PC' ||
    isTouchMac ||
    window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches
  )
}

export { MOBILE_MAX_WIDTH }
